import { createReducer, on, Action } from '@ngrx/store';
import { IMaps } from 'src/app/models/map';
import * as MapActions from '../map/map.action';

export const initialState: IMaps = {
};

const reducer = createReducer(
    initialState,
    on(MapActions.GetMapsApiAction, state => state),

    on(MapActions.SuccessGetMapsApiAction, (state: IMaps, { mapObject }) => ({ ...state, ...mapObject })),
);

export function MapsReducer(state: IMaps | undefined, action: Action) {
    return reducer(state, action);
}

